import { GoogleTagManagerEnums } from "../../shared/utilities/enums/googleTagManagerEnums";
import { ISearchItemBase, SearchItemBase } from "./searchItemBase";


export interface ISearchPage extends ISearchItemBase {
}

export class SearchPage extends SearchItemBase implements ISearchPage {
    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);
    }

    handleClick(event: Event): void {
        super.handleClick(event, GoogleTagManagerEnums.SearchClickListValues.Page);
    }

    dispose(): void {
        super.dispose();
    }
}